import {useUpmPlantTimezone} from '@hconnect/upm'
import React, {FC, useContext} from 'react'

type TimezoneContext = {timezone: string}

const timezoneContext = React.createContext<TimezoneContext | undefined>(undefined)

type ProviderProps = {
  initialState: TimezoneContext
  children: React.ReactNode
}

const TimezoneProvider = ({initialState, children}: ProviderProps) => (
  <timezoneContext.Provider value={initialState}>{children}</timezoneContext.Provider>
)

export const TimezoneProviderByPlantIdWrapper: FC<{
  children: React.ReactNode
  plantId?: string
}> = ({children, plantId}) => {
  const timezone = useUpmPlantTimezone(plantId ?? '')

  if (!plantId) return <></>

  return <TimezoneProvider initialState={{timezone}}>{children}</TimezoneProvider>
}

export function useTimezoneByPlantId() {
  const ctx = useContext(timezoneContext)
  if (ctx === undefined) {
    throw new Error('useTimezone used outside of TimezoneProvider')
  } else {
    return ctx
  }
}
